import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_ADD_SITE_ARTICLES,
  ACTION_CANCEL_SITE_ARTICLE__REQUEST,
  ACTION_CANCEL_SITE_ARTICLE__SUCCESS,
  ACTION_CANCEL_SITE_ARTICLE__FAIL,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_ARTICLES:
      return { ...state, ...action.payload.siteArticles };

    case ACTION_CANCEL_SITE_ARTICLE__SUCCESS:
      return _omit(state, action.payload.siteArticleId);

    default:
      return state;
  }
};

const isSiteArticleBeingCancelled = (state = {}, action) => {
  switch (action.type) {
    case ACTION_CANCEL_SITE_ARTICLE__REQUEST:
      return { ...state, [action.payload.siteArticleId]: true };

    case ACTION_CANCEL_SITE_ARTICLE__SUCCESS:
    case ACTION_CANCEL_SITE_ARTICLE__FAIL:
      return _omit(state, action.payload.siteArticleId);

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isSiteArticleBeingCancelled,
  errors,
});
